export enum CashAcceptorStatusCode {
    OnlineAndReady,
    Offline,
    Failed,
    NoPaper,
    NoInk,
    CashOverflow,
    NoCassette,
    NeedUserIntervention
}